import { LoadableLazy } from '@confluence/loadable';

export const FooterCommentsSummaryCombined = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-FooterCommentsSummaryCombined" */ '../src/FooterCommentsSummaryCombined.tsx'
			)
		).FooterCommentsSummaryCombinedWithErrorBoundary,
});
